import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateField = ({ ...props }) => {
  const { label, required, change } = props;
  const [birthDate, setBirthDate] = useState(null);

  function setVal(val) {
    setBirthDate(val);
    change(val.toISOString());
  }

  return (
    <div>
      <label className='block uppercase tracking-wide text-gray-700 text-sm font-semibold mb-2'>
        {label}
        {required && <span className='text-red-500 ml-1'>*</span>}
      </label>
      <DatePicker
        selected={birthDate}
        showYearDropdown
        showMonthDropdown
        onChange={(date) => setVal(date)}
      />
    </div>
  );
};

DateField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
};

export default DateField;
